import { PublicModulesRouteMap } from '@/new-router/public-modules'
import { UserCenterRouteMap } from '@/new-router/user-center'

const adminAgentList = () => import('@/views/Admin/adminAgentList')
const organizationList = () => import('@/views/Admin/organizationList')
const agentDetails = () => import('@/views/Admin/agentDetails')
const permission = () => import('@/views/Admin/permission')
const permissionEdit = () => import('@/views/Admin/permissionEdit')
const agentList = () => import('@/views/Admin/agentList')
const externalAdminList = () => import('@/views/Admin/externalAdminList')

const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
  }
**/

export default [
  {
    path: '/admin',
    name: 'admin',
    component: Home,
    meta: {
      title: '管理员管理',
      icon: 'icon-administrator',
      showSubiems: false,
      sort: 7,
      modules: 'admin',
      permission: 'admin:root',
    },
    children: [
      {
        path: 'permission',
        name: 'permission',
        component: permission,
        meta: {
          title: '权限管理',
          active: ['permission', 'permissionEdit'],
          permission: 'admin:authority',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.EmployeeManagement],
        },
      }, {
        path: 'permissionEdit/:roleId',
        name: 'permissionEdit',
        component: permissionEdit,
        hidden: true,
        meta: {
          title: '编辑权限',
          nocache: true,
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.EmployeeManagement],
        },
      }, {
        path: 'adminList',
        name: 'adminList',
        component: adminAgentList,
        meta: {
          title: '员工列表',
          active: ['adminList'],
          permission: 'admin:list',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.EmployeeManagement],
        },
      }, {
        path: 'organization',
        name: 'organization',
        component: organizationList,
        meta: {
          title: '部门属性',
          active: ['organization'],
          permission: 'admin:depart',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.EmployeeManagement],
        },
      }, {
        path: 'agentList',
        name: 'agentList',
        component: agentList,
        meta: {
          title: '代理列表',
          active: ['agentList', 'agentDetails'],
          permission: 'agent:label',
          belong: [UserCenterRouteMap.UserCenter, UserCenterRouteMap.AgencyManagement],
        },
      }, {
        path: 'agentDetails/:id/:loginName/:areaName',
        name: 'agentDetails',
        component: agentDetails,
        hidden: true,
        meta: {
          title: '代理信息详情',
          nocache: true,
        },
      }, {
        path: 'externalAdminList',
        name: 'externalAdminList',
        component: externalAdminList,
        meta: {
          title: '外部员工列表',
          active: ['externalAdminList'],
          permission: 'outSideAdmin:list',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.EmployeeManagement],
        },
      },
    ],
  },
]
